import React, { ReactElement, useEffect, useState } from 'react';
import { Modal } from 'antd';
import { EMAIL_VERIFICATION_COMPONENTS } from './emailVerificationConstants';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationDetailModel } from '../../../store/models/applicationDetailModel';
import { RootState } from '../../../store';
import { setEmailVerifyModalShow } from '../../../store/actions/mailBoxAction';
import { MailboxType } from '../../../store/models/mailBoxModel';

const EmailVerificationModal =
  ({}: any): ReactElement => {
    const dispatch = useDispatch();
    const [currIndex, setCurrIndex] = useState(1);
    const [componentNav, setComponentNav] = useState(EMAIL_VERIFICATION_COMPONENTS || []);
    const { component: EmailVerificationModalContent }: any = componentNav[currIndex];
    const goNext = (index: number): any => {
      setCurrIndex(currIndex + index);
    };
    const appDetails = useSelector(
      (state: RootState): ApplicationDetailModel => state.applicationDetail,
    );
    const { isEmailVerificationModalShow } =
    useSelector((state: RootState): MailboxType => state?.mailBox || {});

    useEffect((): void => {
      if (currIndex === 3) {
        setTimeout((): void => {
          dispatch(setEmailVerifyModalShow(false));
        }, 3000);
      }
    }, [currIndex]);

    return (
      <Modal
        centered={true}
        visible={isEmailVerificationModalShow}
        maskClosable={true}
        closable={false}
        footer={null}>
        <EmailVerificationModalContent
          setComponentNav={setComponentNav}
          userEmail={appDetails.getUserEmail()}
          userName={appDetails.getUserName()}
          providerId={appDetails.getProviderId()}
          goNext={goNext} />
      </Modal>
    );
  };

export default EmailVerificationModal;
